// import { createSelector } from '@reduxjs/toolkit';
// Types
import Reducers from 'app/types/Reducers';
// Models
import { RootState } from "app/store";

export const selectLoading = (state:RootState) => state[Reducers.DMSUploads].loading;
export const selectPreSignedUrls = (state:RootState) => state[Reducers.DMSUploads].preSignedUrls;
